import request from "root/js/request";

export const getBloggersPostsSelectionBloggers = async ({
  source__in,
  item__in,
  subject__in = item__in,
  brand_id__in,
  product_id__in,
  limit,
  offset,
  search,
  ...rest
}) => {
  const response = await request({
    url: `parsers/social/posts/bloggers/`,
    method: "get",
    params: {
      source__in,
      item__in,
      subject__in,
      brand_id__in,
      product_id__in,
      limit,
      offset,
      search,
      ...rest,
    },
  });
  return response;
};
